import React, { useState } from "react";
import "./HRAddHoliday.css";
import apiClient from "../utils/apiClient";

const HRAddHoliday = () => {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !date) {
      setMessage("⚠️ Please fill in all fields.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const data = await apiClient("/holiday/", {
        method: "POST",
        body: JSON.stringify({ name, date }),
      });

      // apiClient returns null on 401 or failure
      if (!data) {
        setMessage("❌ Failed to add holiday. Please try again.");
        return;
      }

      setMessage("🎉 Holiday added successfully!");
      setName("");
      setDate("");
    } catch (err) {
      console.error("Error adding holiday:", err);
      setMessage("❌ Error adding holiday.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-holiday-container">
      <h2>Add New Holiday</h2>

      <form className="add-holiday-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Holiday Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter holiday name"
            required
          />
        </div>

        <div className="form-group">
          <label>Holiday Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Adding…" : "Add Holiday"}
        </button>
      </form>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default HRAddHoliday;
